










import dayjs from 'dayjs'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'

@Component({})

export default class DateTooltipped extends Vue {

  @Prop() icon: string
  @Prop() isoDate: string | null
  @Prop({ default: 'YYYY/MM/DD' }) format: string
  @Prop({ default: 'YYYY/M/D dddd HH:mm' }) tooltipFormat: string
  @Prop({ default: 'ندارد' }) defaultText: string

  get dayInstance() {
    return dayjs(this.isoDate)
  }

  get dateFromNow() {
    if (!Boolean(this.isoDate)) return this.defaultText
    if (this.format) {
      return this.dayInstance.format(this.format)
    } else {
      return this.dayInstance.fromNow()
    }
  }

  get dateTooltip() {
    return this.dayInstance.format(this.tooltipFormat)
  }
}
